export class StudentEngagementListRequest {
    exerciseId: number;
    zoneId: number;
    schoolId: number;
  }